import React, { Component, Fragment } from "react";
import { compose } from "redux";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { Typography, Snackbar, Button } from "@mui/material";
import { withRouter } from "react-router";
import moment from "moment-timezone";
import OfferDetails from "../OfferDetails";
import { Form, Formik } from "formik";
import OfferForm from "../OfferForm";
import { info } from "core/Offers/validations";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Translation, withTranslation } from "react-i18next";
import { TARGET_PREFIXES } from "common/constants";

class AdminOfferReview extends Component {
  state = {
    snackbar: null,
    editing: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const prevOfferStatus = prevProps.offer.status;
    const latestOfferStatus = this.props.offer.status;
    const prevTimestamp = prevProps.offer.updated_at;
    const latestTimestamp = this.props.offer.updated_at;

    if (
      prevOfferStatus !== latestOfferStatus ||
      !moment(prevTimestamp).isSame(latestTimestamp)
    ) {
      this.showSnackbar(latestOfferStatus);
    }
  }

  showSnackbar(status) {
    const { t } = this.props;
    if (status === "approved") {
      this.setState({ snackbar: "Offer has been approved" });
    } else {
      this.setState({ snackbar: t("offer_view.offer_update_success") });
    }
  }

  handleApprove = () => {
    this.props.handleApprove();
  };

  handleDeleteRequest = () => {
    this.setState({ deleteDialogOpen: true });
  };

  handleDeleteConfirm = () => {
    this.setState({ deleteDialogOpen: false });
    this.props.handleDelete();
  };

  handleDeleteCancel = () => {
    this.setState({ deleteDialogOpen: false });
  };

  handleSubmit = (values, form) => {
    const { target } = values;
    if (
      typeof target === "string" &&
      target.startsWith(TARGET_PREFIXES.group)
    ) {
      values.target = "group";
      values.event_id = null;
      values.building_group_id = parseInt(
        target.slice(TARGET_PREFIXES.group.length),
        10,
      );
    } else if (target !== "community" && target !== "building") {
      values.event_id = values.target;
      values.target = "event";
      values.building_group_id = null;
    } else {
      values.event_id = null;
      values.building_group_id = null;
    }
    this.setEditing(false);
    this.props.handleResubmit(values);
  };

  handleSnackbarClose = () => {
    this.setState({ snackbar: null });
  };

  setEditing = (editing) => {
    this.setState({ editing });
  };

  renderSnackbar = () => {
    const { snackbar } = this.state;

    if (!snackbar) {
      return null;
    }

    return (
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={!!snackbar}
        autoHideDuration={4000}
        onClose={this.handleSnackbarClose}
        message={<span>{snackbar}</span>}
      />
    );
  };

  renderDeleteDialog = (t) => {
    return (
      <Dialog open onClose={this._closeDialog}>
        <DialogTitle>{t("offer_view.delete_popup_title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("offer_view.delete_popup_content")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleDeleteCancel}>
            {t("offer_view.delete_popup_cancel_btn")}
          </Button>
          <Button autoFocus onClick={this.handleDeleteConfirm}>
            {t("offer_view.delete_popup_confirm_btn")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const { offer, timezone, template, classes, history } = this.props;
    const { editing, deleteDialogOpen } = this.state;

    const initialValues = {
      ...offer,
      offer_template: template,
      legal: offer.legal || template.legal,
      defaultTerms: !offer.legal,
      start_at: moment(offer.start_at).tz(timezone),
      end_at: moment(offer.end_at).tz(timezone),
      quantity: offer.quantity || "",
      target:
        offer.target === "group" && offer.building_group_id
          ? `${TARGET_PREFIXES.group}${offer.building_group_id}`
          : offer.event_id
            ? offer.event_id
            : offer.target,
    };

    return (
      <Translation>
        {(t) => (
          <Fragment>
            <Grid container direction="row" spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Grid container direction="row" alignItems="center">
                  <Grid size={{ xs: 6 }}>
                    <Typography variant="h5">{offer.name}</Typography>
                  </Grid>
                  {/* <Grid size={{ xs: 4 }}>
                    <OfferStatus status={offer.status} variant='body2' />
                  </Grid> */}
                </Grid>
              </Grid>
              {editing ? (
                <Grid size={{ xs: 12 }}>
                  <Formik
                    initialValues={initialValues}
                    enableReinitialize={false}
                    validationSchema={info(t)}
                    onSubmit={this.handleSubmit}
                  >
                    {(formikProps) => (
                      <Form onSubmit={formikProps.handleSubmit}>
                        <Grid container direction="row" spacing={2}>
                          <Grid size={{ xs: 12 }}>
                            <OfferForm
                              {...formikProps}
                              eventTargets={this.props.eventTargets}
                              groupTargets={this.props.groupTargets}
                              timezone={timezone}
                            />
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <Grid
                              container
                              direction="row"
                              justifyContent="space-between"
                            >
                              <Button
                                className={classes.button}
                                onClick={() => history.goBack()}
                              >
                                {t("offer_view.back_btn")}
                              </Button>

                              <div>
                                <Button
                                  onClick={() => this.setEditing(false)}
                                  className={classes.button}
                                >
                                  {t("offer_view.cancel_btn")}
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  type="submit"
                                  className={classes.button}
                                >
                                  {/* {t('offer_view.resubmit_btn')} */}
                                  {t("offer_view.update_btn")}
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Grid>
              ) : (
                <Fragment>
                  <Grid size={{ xs: 12 }}>
                    <OfferDetails
                      values={offer}
                      timezone={timezone}
                      template={template}
                      eventTargets={this.props.eventTargets}
                      groupTargets={this.props.groupTargets}
                    />
                  </Grid>
                  <Grid size={{ xs: 6 }}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Button
                        className={classes.button}
                        onClick={() => history.goBack()}
                      >
                        {t("offer_view.back_btn")}
                      </Button>

                      <div>
                        {offer.status === "submitted" ? (
                          <Button
                            color="secondary"
                            onClick={this.handleDeleteRequest}
                            className={classes.button}
                          >
                            <DeleteIcon />
                            {t("offer_view.delete_btn")}
                          </Button>
                        ) : null}

                        {/* {offer.status === 'change_request' ? ( */}
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => this.setEditing(true)}
                          className={classes.button}
                        >
                          {t("offer_view.edit_btn")}
                        </Button>
                        {/* <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleApprove}
                            className={classes.button}
                          >
                            {t("offer_view.accept_btn")}
                          </Button> */}
                      </div>
                      {/* ) : null} */}
                    </Grid>
                  </Grid>
                </Fragment>
              )}
            </Grid>

            {this.renderSnackbar()}
            {deleteDialogOpen ? this.renderDeleteDialog(t) : null}
          </Fragment>
        )}
      </Translation>
    );
  }
}

AdminOfferReview.propTypes = {
  offer: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired,
  template: PropTypes.object.isRequired,
  handleApprove: PropTypes.func.isRequired,
  handleResubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  eventTargets: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  groupTargets: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

const styles = (theme) => ({
  button: {
    marginRight: theme.spacing(1),
    fontWeight: "bold",
    fontSize: "0.875rem",
  },
});

const enhanced = compose(withStyles(styles), withRouter, withTranslation());

export default enhanced(AdminOfferReview);
